
interface ListenersType {
    [key: string]: EventListenerOrEventListenerObject;
  }
class GameCustomEventService  {
    
    static listeners: ListenersType = {};

    static addGameEventListner(event: string, dispatcherName: string, handler: EventListenerOrEventListenerObject) {
        GameCustomEventService.listeners[dispatcherName] = handler;
        window.addEventListener(event, handler);
    }

    static dispatchGameEvent(event: string, options: object = {}) {
        const gameCustomEvent: CustomEvent = new CustomEvent(
            event,
            { detail: {...options} }
        );
       window.dispatchEvent(gameCustomEvent);
    }

    static removeGameEventListners(event: string, dispatcherName: string){
      window.removeEventListener(event, GameCustomEventService.listeners[dispatcherName])
    }
}

export default GameCustomEventService;
